import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import * as aor from "react-admin";
import {
    Button,
    Fade,
    Snackbar,
    Divider,
    TextField,
    InputAdornment,
    IconButton,
    Tooltip
} from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import { withStyles } from "@material-ui/core/styles";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import history from "../common/history";

import TranslatedText from "./TranslatedText";
import authClient, { getLoggedUser } from "../common/authClient";
import { isStaging } from "../common/utilities";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = theme => ({
    appLogo: { margin: 20, paddingTop: 20 },
    card: {
        width: 550,
        margin: "auto"
    },
    button: {
        marginBottom: 10,
        margin: theme.spacing.unit,
        background:
            isStaging() === true
                ? tccStyles.stagingColor.primary
                : tccStyles.productionColor.primary,
        width: "30%",
        color: "white",
        "&:hover": {
            background:
                isStaging() === true
                    ? tccStyles.stagingColor.primary
                    : tccStyles.productionColor.primary
        }
    },
    cssFocused: {},
    cssUnderline: {
        "&:after": {
            borderBottomColor: "black"
        }
    },
    formLabelRoot: {
        "&$formLabelFocused": { color: "grey" }
    },
    formLabelFocused: {}
});

class ResetPassword extends React.Component {
    state = {
        logged: false,
        password_token: null,
        showMessageLinkSent: false,
        password_changed: false,
        errorText: "",
        password: null,
        confirmPassword: null,
        passwordsMatches: false,
        showInvalidToken: false,
        showExpiredToken: false,
        error: false,
        showPassword: false,
        showConfirmPassword: false,
        email: "",
        message: "",
        confirmForgotPassword: true,
        token_email: ""
    };

    componentDidMount() {
        const {
            match: { params }
        } = this.props;
        getLoggedUser().then(logged_user => {
            if (params.pwd_token) {
                myRestClient("GET_ONE", "email", { id: params.pwd_token })
                    .then(result => {
                        if (
                            logged_user &&
                            result.data.email !== logged_user.username
                        ) {
                            this.setState({
                                password_token: params.pwd_token,
                                logged: logged_user ? true : false,
                                token_email: result.data.email,
                                showInvalidToken: true
                            });
                        } else {
                            this.setState({
                                password_token: params.pwd_token,
                                logged: logged_user ? true : false,
                                token_email: result.data.email
                            });
                        }
                    })
                    .catch(e => {
                        this.setState({
                            password_token: params.pwd_token,
                            logged: logged_user ? true : false,
                            token_email: null,
                            showInvalidToken: true
                        });
                    });
            } else {
                this.setState({
                    password_token: params.pwd_token,
                    logged: logged_user ? true : false,
                    token_email: null
                });
            }
        });
    }

    //invia la richiesta di reset link al server
    handleRequestResetLink = () => {
        myRestClient("GET_ONE", "password", null).then(result => {
            this.setState({ showMessageLinkSent: true });
        });
    };

    // reindirizza al profilo
    handleClose = () => {
        history.push("/profile");
    };

    handleCloseAndLogout = () => {
        authClient(aor.AUTH_LOGOUT);
        history.push("/profile");
    };

    handlePasswordChange = e => {
        this.setState({
            passwordsMatches:
                this.state.confirmPassword === e.target.value &&
                e.target.value !== ""
                    ? true
                    : false
        });
        this.setState({ password: e.target.value });
    };

    handlePasswordChangeConfirm = e => {
        this.setState({
            passwordsMatches:
                this.state.password === e.target.value && e.target.value !== ""
                    ? true
                    : false
        });
        this.setState({ confirmPassword: e.target.value });
    };

    handleEmailPasswordForgot = e => {
        this.setState({ email: e.target.value });
    };

    handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    handleClickShowPasswordConfirm = () => {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
    };
    handleClick = () => {
        this.setState({ errorText: "" });
        const { password, password_token, confirmPassword } = this.state;
        const query = {
            data: {
                pwd_token: password_token,
                pwd: password,
                pwd_confirm: confirmPassword
            }
        };
        myRestClient("CREATE", "password", query).then(
            result => {
                this.setState({
                    showSnackBar: false,
                    message: "Password aggiornata",
                    error: false,
                    password_changed: true
                });
            },
            error => {
                if (error.message === "Password token not found") {
                    this.setState({
                        error: false,
                        showSnackBar: false,
                        message: error.message,
                        showInvalidToken: true
                    });
                }
                if (error.message === "Password token expired") {
                    this.setState({
                        error: false,
                        showSnackBar: false,
                        message: error.message,
                        showExpiredToken: true
                    });
                }
                if (
                    error.message === "New password must be differ from old one"
                ) {
                    this.setState({
                        error: true,
                        showSnackBar: true,
                        message: error.message,
                        errorText:
                            "La password deve essere differente da quella attuale"
                    });
                }
                if (
                    error.message ===
                    "Password not accepted because same as user name"
                ) {
                    this.setState({
                        error: true,
                        showSnackBar: true,
                        message: error.message,
                        errorText:
                            "La password deve essere differente dal nome utente"
                    });
                }
                if (error.message === "Password doesn't meet requirements") {
                    this.setState({
                        error: true,
                        showSnackBar: true,
                        message: error.message,
                        errorText: "La password non soddisfa i requisiti"
                    });
                }
            }
        );
    };
    handleClickForgotPassword = () => {
        if (this.state.confirmForgotPassword) {
            this.setState({ errorText: "", confirmForgotPassword: false });
            const { email } = this.state;
            const query = {
                filter: { email: email },
                pagination: { page: 1, perPage: 1 },
                sort: { field: "username", order: "asc" }
            };
            myRestClient("GET_LIST", "recover-password", query).then(
                result => {
                    this.setState({
                        error: false,
                        showSnackBar: true,
                        message:
                            "Se l'account è valido, riceverai un'email con il link per reimpostare la password",
                        email: "",
                        confirmForgotPassword: true
                    });
                },
                error => {
                    if (error.message) {
                        this.setState({
                            error: true,
                            showSnackBar:
                                error.message === "Body validation failed"
                                    ? false
                                    : true,
                            message: error.message,
                            errorText:
                                error.message === "Body validation failed"
                                    ? "Inserire un indirizzo email valido"
                                    : error.message,
                            confirmForgotPassword: true
                        });
                    }
                }
            );
        }
    };

    renderSnackMessage() {
        return (
            <span
                style={{
                    color:
                        this.state.error === true
                            ? tccStyles.snackbar.errorColor
                            : tccStyles.snackbar.color
                }}
            >
                <TranslatedText resource_name={this.state.message} />
            </span>
        );
    }

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={5000}
                TransitionComponent={Fade}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={this.renderSnackMessage()}
            />
        );
    }

    // visualizza il messaggio di invio reset link avvenuto
    renderLinkSent(classes) {
        return (
            <div>
                <aor.ViewTitle title="Link per reimpostare la password inviato" />
                <CardContent>
                    <p>
                        È stata inviata una mail all'indirizzo associato a
                        questo account con un link per reimpostare la password.
                    </p>
                    <div align="center">
                        <Divider />
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={this.handleClose}
                            className={classes.button}
                        >
                            OK
                        </Button>
                    </div>
                </CardContent>
            </div>
        );
    }

    // visualizza la conferma prima di inviare il reset link
    renderConfirmResetPassword(classes) {
        return (
            <div>
                <aor.ViewTitle title="Reimposta password" />
                <CardContent>
                    <p>Confermare di voler reimpostare la password?</p>

                    <div align="center">
                        <Divider />
                        <span>
                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                onClick={this.handleRequestResetLink}
                            >
                                conferma
                            </Button>

                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                onClick={this.handleClose}
                            >
                                Annulla
                            </Button>
                        </span>
                    </div>
                </CardContent>
            </div>
        );
    }

    renderPasswordChanged(classes) {
        return (
            <div>
                {!this.state.logged && (
                    <div align="center" className={classes.appLogo}>
                        <img
                            src="/static/images/logo_ts.png"
                            alt="Logo"
                            width="100px"
                        />
                        <span className={classes.appTitle}>
                            <div style={{ marginTop: 20 }}>
                                <Typography component="h2" variant="display1">
                                    TeamSystem Cloud Console
                                </Typography>
                            </div>
                        </span>
                    </div>
                )}
                <aor.ViewTitle title="La password è stata cambiata" />
                <CardContent>
                    <p>
                        La password è stata cambiata con successo. Effettua
                        nuovamente il login con le nuove credenziali.
                    </p>
                    <div align="center">
                        <Divider />
                        <span>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={this.handleCloseAndLogout}
                                className={classes.button}
                            >
                                OK
                            </Button>
                        </span>
                    </div>
                </CardContent>
            </div>
        );
    }

    renderInvalidToken(classes, title, message) {
        return (
            <div>
                {!this.state.logged && (
                    <div align="center" className={classes.appLogo}>
                        <img
                            src="/static/images/logo_ts.png"
                            alt="Logo"
                            width="100px"
                        />
                        <span className={classes.appTitle}>
                            <div style={{ marginTop: 20 }}>
                                <Typography component="h2" variant="display1">
                                    TeamSystem Cloud Console
                                </Typography>
                            </div>
                        </span>
                    </div>
                )}
                <aor.ViewTitle title={title} />
                <CardContent>
                    <p>{message}</p>
                    <div align="center">
                        <Divider />
                        <span>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={this.handleClose}
                                className={classes.button}
                            >
                                OK
                            </Button>
                        </span>
                    </div>
                </CardContent>
            </div>
        );
    }

    renderChangePassword(classes) {
        return (
            <div>
                {!this.state.logged && (
                    <div align="center" className={classes.appLogo}>
                        <img
                            src="/static/images/logo_ts.png"
                            alt="Logo"
                            width="100px"
                        />
                        <span className={classes.appTitle}>
                            <div style={{ marginTop: 20 }}>
                                <Typography component="h2" variant="display1">
                                    TeamSystem Cloud Console
                                </Typography>
                            </div>
                        </span>
                    </div>
                )}
                <tb>
                    <tr>
                        <td width="80px"></td>
                        <td>
                            {this.state.token_email ? (
                                <aor.ViewTitle
                                    title={
                                        "Inserire la nuova password per " +
                                        this.state.token_email
                                    }
                                />
                            ) : (
                                <aor.ViewTitle title="Inserire la nuova password" />
                            )}
                            <form noValidate autoComplete="off">
                                <div
                                    style={{
                                        marginLeft: 30,
                                        marginTop: 0
                                    }}
                                >
                                    <TextField
                                        id="password"
                                        label="Password"
                                        onChange={this.handlePasswordChange}
                                        type={
                                            this.state.showPassword
                                                ? "text"
                                                : "password"
                                        }
                                        InputLabelProps={{
                                            FormLabelClasses: {
                                                root: classes.formLabelRoot,
                                                focused:
                                                    classes.formLabelFocused
                                            }
                                        }}
                                        InputProps={{
                                            className: classes.cssUnderline,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="Toggle password visibility"
                                                        onClick={
                                                            this
                                                                .handleClickShowPassword
                                                        }
                                                    >
                                                        {this.state
                                                            .showPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={
                                            this.state.errorText.length === 0
                                                ? false
                                                : true
                                        }
                                        helperText={this.state.errorText}
                                    />
                                    <Tooltip
                                        placement="left"
                                        title={
                                            <TranslatedText resource_name="invalid_password" />
                                        }
                                    >
                                        <HelpIcon
                                            style={{
                                                verticalAlign: "bottom",
                                                marginLeft: 20,
                                                marginBottom: 3
                                            }}
                                        />
                                    </Tooltip>
                                </div>
                                <br />
                                <div
                                    style={{
                                        marginLeft: 30,
                                        marginTop: 20,
                                        paddingBottom: 20
                                    }}
                                >
                                    <TextField
                                        id="confirmPassword"
                                        label="Conferma password"
                                        onChange={
                                            this.handlePasswordChangeConfirm
                                        }
                                        type={
                                            this.state.showConfirmPassword
                                                ? "text"
                                                : "password"
                                        }
                                        InputLabelProps={{
                                            FormLabelClasses: {
                                                root: classes.formLabelRoot,
                                                focused:
                                                    classes.formLabelFocused
                                            }
                                        }}
                                        InputProps={{
                                            className: classes.cssUnderline,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="Toggle password visibility"
                                                        onClick={
                                                            this
                                                                .handleClickShowPasswordConfirm
                                                        }
                                                    >
                                                        {this.state
                                                            .showConfirmPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={
                                            this.state.errorText.length === 0
                                                ? false
                                                : true
                                        }
                                        helperText={this.state.errorText}
                                    />
                                </div>
                            </form>
                        </td>
                    </tr>
                </tb>
                <br />
                <Divider />
                <div align="center">
                    <span>
                        <Button
                            disabled={!this.state.passwordsMatches}
                            onClick={this.handleClick}
                            variant="contained"
                            className={classes.button}
                        >
                            Conferma
                        </Button>
                        {this.state.logged && (
                            <Button
                                onClick={this.handleClose}
                                variant="contained"
                                className={classes.button}
                            >
                                Annulla
                            </Button>
                        )}
                    </span>
                </div>
            </div>
        );
    }

    renderForgotPassword(classes) {
        return (
            <React.Fragment>
                <div
                    style={{
                        marginLeft: 30,
                        marginRight: 30,
                        marginTop: 30,
                        marginBottom: 30
                    }}
                >
                    <div className={classes.appLogo} align="center">
                        <img
                            src="/static/images/logo_ts.png"
                            alt="Logo"
                            width="100px"
                        />
                    </div>
                    <span className={classes.appTitle} align="center">
                        <Typography component="h2" variant="display1">
                            TeamSystem Cloud Console
                        </Typography>
                    </span>
                    <br />
                    <br />
                    <span align="center">
                        <Typography component="h3" variant="display1">
                            RECUPERO PASSWORD
                        </Typography>
                    </span>
                    <br />
                    <p>
                        Per recuperare la password inserire l'e-mail assocciata
                        all'account.
                    </p>
                    <TextField
                        id="email"
                        label="E-mail"
                        type={"text"}
                        style={{ width: "100%" }}
                        value={this.state.email}
                        onChange={this.handleEmailPasswordForgot}
                        onBlur={this.handleEmailPasswordForgot}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: classes.formLabelRoot,
                                focused: classes.formLabelFocused
                            }
                        }}
                        InputProps={{
                            className: classes.cssUnderline,
                            endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                            )
                        }}
                        error={this.state.errorText.length === 0 ? false : true}
                        helperText={this.state.errorText}
                    />
                </div>
                <div align="center">
                    <span>
                        <Button
                            color="primary"
                            disabled={!this.state.confirmForgotPassword}
                            onClick={this.handleClickForgotPassword}
                            variant="contained"
                            className={classes.button}
                        >
                            {!this.state.confirmForgotPassword && (
                                <CircularProgress size={16} />
                            )}
                            Conferma
                        </Button>
                        <Button
                            color="primary"
                            onClick={this.handleClose}
                            variant="contained"
                            className={classes.button}
                        >
                            Annulla
                        </Button>
                    </span>
                </div>
                <br />
            </React.Fragment>
        );
    }
    render() {
        const { classes } = this.props;
        return (
            <div>
                <Card className={classes.card}>
                    {this.state.password_token
                        ? this.state.showInvalidToken
                            ? this.renderInvalidToken(
                                  classes,
                                  "Il link di reset password non è valido",
                                  "Il link utilizzato non è valido. Per favore riprova a reimpostare la password dal tuo profilo o contatta un amministratore."
                              )
                            : this.state.showExpiredToken
                            ? this.renderInvalidToken(
                                  classes,
                                  "Il link di reset password è scaduto",
                                  "Il link utilizzato è scaduto. Per favore riprova a reimpostare la password dal tuo profilo o contatta un amministratore."
                              )
                            : this.state.password_changed
                            ? this.renderPasswordChanged(classes)
                            : this.renderChangePassword(classes)
                        : !this.state.logged
                        ? this.renderForgotPassword(classes)
                        : this.state.showMessageLinkSent
                        ? this.renderLinkSent(classes)
                        : this.renderConfirmResetPassword(classes)}
                </Card>
                {this.renderSnackBar()}
            </div>
        );
    }
}

export default withStyles(styles)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js